import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0b291cea"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "tagged-text"
};
export function render(_ctx, _cache) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("span", null, [_renderSlot(_ctx.$slots, "default", {}, undefined, true)])]);
}